import * as types from './constants';

// Get Verified Domains
export const getVerifiedDomainsRequest = data => (
  { type: types.GET_VERIFIED_DOMAINS_REQUEST, payload: data }
);

export const getVerifiedDomainsDone = data => (
  { type: types.GET_VERIFIED_DOMAINS_DONE, payload: data }
);

export const getVerifiedDomainsFailed = errors => (
  { type: types.GET_VERIFIED_DOMAINS_FAILED, payload: errors }
);

// Operations
export const verifiedDomainsSetPage = data => (
  { type: types.VERIFIED_DOMAINS_SET_PAGE, payload: data }
);